module.exports = __webpack_public_path__ + "img/ortodontia.333ca71e.png";